import { PrintQR } from 'components/Cards';
import { useState , useEffect } from 'react';
import { useHistory } from 'react-router-dom';
import { useStore } from 'store';
import { setGiftTable } from 'store/actions/giftTable'
import { showLoader, hideLoader } from 'store/actions/commons';
import iconHamburger from 'assets/img/menuIcon.png';
import { decodeStorageLatin, encodeStorageLatin, encodeStorage, decodeStorage } from 'functions/storageBase64';
import useEventGifts from 'newHooks/useEventGifts';
import RegaloIcon from 'assets/img/iconregalo.svg';
import CelIcon from 'assets/img/cel.png';
import MsgIcon from 'assets/img/msg.png';
import styles from './styles.module.sass'


const SelectEvent = (props) => {

    const {
        sendProducts,
        setResponseTable,
        setTotal,
        setIsEmpty
    } = props

    // const GIFT_TABLE_DATA = decodeStorageLatin('GIFT_TABLE_DATA') || null
    // const CURRENT_GIFT_TABLE = decodeStorageLatin('CURRENT_GIFT_TABLE') || null
    const [ listOfGiftsTables, dispatch ] = useStore( (state) => state?.giftTable?.myListOfGiftsTables?.results?.list )
    const [ tableData, ] = useStore( (state) => state?.giftTable)
    const [ listOfTables, setListOfTables ] = useState(null)
    const [ changeTable, setChangeTable ] = useState(false)
    const [ actualEvent, setActualEvent ] = useState(false)
    const [ storageData, setStorageData ] = useState(false)
    const history = useHistory();
    const routeUrl = window.location.search

    const [ validationNull, setValidationNull ] = useState(false)

    const [ firstTime, setFirstTime ] = useState(false)

    const [showHeader, setShowHeader ] = useState(true)

    useEffect(()=>{
        const agentStaff = routeUrl?.indexOf('agent_staff')
        // const agentID = routeUrl?.indexOf('agent_table_id')
        
        if(agentStaff >= 1){
            setShowHeader(false)
        }
    },[])

    const handleChange = (event) => {
        const { value } = event.target
        setChangeTable(listOfTables[value])
        dispatch(showLoader())
    }

    const {
        getEventTable,
        responseTable,
        respProducts,
        isEmpty
    } = useEventGifts()

    useEffect(()=>{

        // setStorageData(GIFT_TABLE_DATA)
        const agentStaff = routeUrl?.indexOf('agent_staff')
        try{
            if(agentStaff >= 1){
                setStorageData( decodeStorage('CURRENT_GIFT_TABLE') || null )
            }else{
                setStorageData( decodeStorage('GIFT_TABLE_DATA') || null )
            }
            
        }catch(err){
            if(agentStaff >= 1){
                setStorageData( decodeStorageLatin('CURRENT_GIFT_TABLE') || null )
            }else{
                setStorageData( decodeStorageLatin('GIFT_TABLE_DATA') || null )
            }
        }

        // console.log( localStorage.getItem('R0lGVF9UQUJMRV9EQVRB')  )
        // console.log( localStorage.getItem('Q1VSUkVOVF9HSUZUX1RBQkxF')  )
        // console.log( atob('R0lGVF9UQUJMRV9EQVRB')  )
        // console.log( atob('Q1VSUkVOVF9HSUZUX1RBQkxF')  )

        // console.log('GIFT_TABLE_DATA parse:  ', JSON.parse( atob( localStorage.getItem('R0lGVF9UQUJMRV9EQVRB') ) )?.gifts )
        // console.log('CURRENT_GIFT_TABLE parse:  ', JSON.parse( atob( localStorage.getItem('Q1VSUkVOVF9HSUZUX1RBQkxF') ) )?.gifts )

        if( localStorage.getItem('R0lGVF9UQUJMRV9EQVRB') === null || localStorage.getItem('Q1VSUkVOVF9HSUZUX1RBQkxF') === null ){
            if(!showHeader){
                setTimeout( () => {
                    setValidationNull(true) 
                }, 1500 )
            }
        }
    },[])

    useEffect(()=>{
        if(validationNull){
            if( localStorage.getItem('R0lGVF9UQUJMRV9EQVRB') === null || localStorage.getItem('Q1VSUkVOVF9HSUZUX1RBQkxF') === null ){
                // console.log('ya valio barriga sr ver....')
                history.push('/crear-mesa')
            }
        }
    },[validationNull])

    useEffect(()=>{
        setFirstTime(false)
        if(storageData){
            setActualEvent(storageData)
            if(sendProducts){
                const id = storageData?.id
                getEventTable(id)
                dispatch(showLoader())
            }
        }else if(tableData?.id || tableData?.evento){
            const id = tableData?.id || tableData?.evento
            if(id){
                setActualEvent(tableData)
                if(sendProducts){
                    getEventTable(id)
                    dispatch(showLoader());
                }
            }
        }else if(tableData?.giftTable?.id){
            if(sendProducts){
                const id = tableData?.giftTable?.id
                if(id){
                    getEventTable(id)
                    dispatch(showLoader());
                }
            }
            else{
                if(tableData?.giftTable?.gifts){
                    setActualEvent(tableData?.giftTable)
                    // setActualEvent(tableData?.giftTable?.id)
                    
                }else if(tableData?.giftTable?.id){
                    const id = tableData?.giftTable?.id || tableData?.giftTable?.evento
                    getEventTable(id)
                    dispatch(showLoader());
                }
                setActualEvent(tableData?.giftTable)
            }
        }else if(storageData === null){
            setTimeout(()=>{
                const GT = decodeStorageLatin('CURRENT_GIFT_TABLE')
                setActualEvent(GT)
                setFirstTime(true)
            },1000)
            
        }else{
            // console.log('Headers 6 no hay nada de datos ', storageData)

        }
    },[ storageData, firstTime ])

    useEffect(()=>{
        if(responseTable){
            const newEvent = {
                ...responseTable,
                evento: responseTable?.id
            }

            try{
                encodeStorage('CURRENT_GIFT_TABLE', newEvent)
            }catch(err){
                encodeStorageLatin('CURRENT_GIFT_TABLE', newEvent)
            }

            setActualEvent(responseTable)
        }
    },[ responseTable ])
       

    useEffect(()=>{
        if(listOfGiftsTables){

            // console.log('listOfGiftsTables: ',listOfGiftsTables)
            // console.log('storageData?.id: ',storageData?.id)
            // console.log('tableData?.giftTable?.id: ',tableData?.giftTable?.id)

            const idEventStorage = storageData?.id
            // console.log('idEventStorage: ',idEventStorage)

            if(listOfGiftsTables?.length >= 1){
                const listTables = listOfGiftsTables?.filter(tables => tables?.estatus === 'Open')

                if(listTables?.length >= 1){
                    setListOfTables(listTables)
                    // console.log('listTables: ',listTables)
                }else{
                    const listTablesNull = listOfGiftsTables?.filter(tables => tables?.evento === idEventStorage)

                    const agentStaff = routeUrl?.indexOf('agent_staff')
                    if(agentStaff >= 1){
                        setListOfTables(listTables)
                    }else{
                        setListOfTables(listTablesNull)
                        // const listTablesNull = listOfGiftsTables
                        // console.log('listTablesNull: ',listTablesNull)
                    }
                }

            }
        }
    },[ listOfGiftsTables ])


    useEffect(()=>{
        if(changeTable){
            if(changeTable?.evento){
                try{
                    encodeStorage('CURRENT_GIFT_TABLE', changeTable)
                }catch(err){
                    encodeStorageLatin('CURRENT_GIFT_TABLE', changeTable)
                }
                getEventTable(changeTable?.evento)
            }
            dispatch(setGiftTable(changeTable))
        }
    },[ changeTable ])

    useEffect(()=>{
        if(actualEvent){
            const newEvent = {
                ...actualEvent,
                evento: actualEvent?.id
            }            
            try{
                // encodeStorage('CURRENT_GIFT_TABLE', newEvent)
                encodeStorage('GIFT_TABLE_DATA', newEvent)
            }catch(err){
                // encodeStorageLatin('CURRENT_GIFT_TABLE', newEvent)
                encodeStorageLatin('GIFT_TABLE_DATA', newEvent)
            }
            dispatch(setGiftTable(newEvent))
            // console.log('---------------------')
            // console.log('Headers 7 newEvent: ',newEvent?.gifts)
            
            setResponseTable(actualEvent)

            setTimeout(()=>{
                dispatch(hideLoader());
            },2500)
        }
    },[ actualEvent ])

    useEffect(()=>{
        if(respProducts){
            setTotal(respProducts)
            dispatch(hideLoader())
        }
    },[ respProducts ])
            
    useEffect(()=>{
        if(isEmpty){
            // console.log('Headers 9 isEmpty: ',isEmpty)
            setIsEmpty(isEmpty)
            dispatch(hideLoader())
        }
    },[ isEmpty ])

    useEffect(()=>{
        if(tableData?.giftTable?.gifts){
            if(respProducts){

                const allProducts = respProducts
                const includedIds = new Set(tableData?.giftTable?.gifts.map(product => product.product_id))
                const updateProducts = allProducts.filter(product => includedIds.has(product.id))

                // console.log('Headers 10 respProducts: : ',respProducts)
                // console.log('Headers 11 includedIds: : ',includedIds)
                // console.log('Headers 12 updateProducts: : ',updateProducts)

                if(updateProducts?.length >= 1){
                    setTotal(updateProducts)
                }
                else{
                    setTotal([])
                    setIsEmpty(true)
                }

            }
        }
    },[tableData?.giftTable?.gifts, respProducts])


    return(
        <div className={styles?.contSelect}>
            <select className={styles?.select} onChange={handleChange}>
                <option selected disabled>Mesa # {actualEvent?.id}</option>
                    {listOfTables?.length > 1
                        ?
                            listOfTables.map((item, index) => (
                                <option key={item?.id} value={index}>
                                    Mesa #{item?.evento} {item?.tipo}
                                </option>
                            ))
                        : null
                    }
            </select>
        </div>
    )
}

const InternalMenu = () => {

    const history = useHistory()
    const [currentGiftTable] = useStore(
        (state) => state.giftTable.giftTable
    );
    const showMenuRoutes = [
        {title:'Mis mesas', url:'/mis-mesas', action:'navigate', id:1, onlyShow: 'desktopClass'},
        {title:'Crear Mesas', url:'/crear-mesa', action:'navigate', id:2, onlyShow: 'desktopClass'},
        {title:'Preguntas frecuentes', url:'/faqs', action:'navigate', id:3, onlyShow: 'desktopClass'},
        {title:'Reseñas', url: '/review', action:'navigate', id:4, onlyShow: 'desktopClass'}
    ]

    const [ activeMenu, setActiveMenu ] = useState(false)
    const [ getOpenModal, setOpenModal ] = useState(false);

    const handleAction = (props) => {
        const {url, action} = props
        const ruta =  window.location.pathname.split('/Mesa-de-Regalos')[1]
        if(action === 'navigate'){
            if(url !== ruta){
                history.push(url)
            }else{
                setActiveMenu(false)
            }
        }
        if(action === 'modal'){
            setOpenModal(true)
        }
    }

    const handleCloseModal = () => {
        setOpenModal(false);
    };

    const handleClickSetting = () =>{
        setActiveMenu(!activeMenu)
    }


    return(
        <>
            <div className={styles?.contMenuFloat}>
                <img
                    src={iconHamburger}
                    onClick={handleClickSetting}
                    alt="menu"
                    aria-hidden
                />
                <ul className={activeMenu ? `${styles?.floatMenu} ${styles?.active}`: styles?.floatMenu}>
                    {
                        showMenuRoutes.map(( navigate ) => (
                            <li 
                                key={navigate?.id} 
                                onClick={() => handleAction({url: navigate?.url, action: navigate?.action})}
                                className={ styles[navigate?.onlyShow] }
                                aria-hidden
                            >{navigate?.title}</li>
                        ))
                    }
                </ul>
            </div>
            
            <div className={activeMenu ? `${styles?.menuModal} ${styles?.active}`:styles?.menuModal}>
                <div className={styles?.contMenuModal}>
                    <h2 className={styles?.contTitleMenu}>Mesa de Regalos SEARS</h2>
                    <span className={styles?.closeBtn} onClick={handleClickSetting} aria-hidden>X</span>

                    <dl>
                        <dt className={`${styles?.titlesSubMenu} ${styles?.firstChild}`}>
                            <img className={styles?.imageClass} src={RegaloIcon} alt="msgicon" height="20" />
                            <p>Evento #{currentGiftTable.evento}</p>
                        </dt>
                        <dd>
                            <ul className={styles?.floatMenuMobile}>
                                <li
                                    onClick={() => handleAction({url: '/my-table', action: 'navigate'})}
                                    className={ `${styles?.movilClass} ${styles?.linksUrl}` }
                                    aria-hidden
                                >Mi mesa</li>
                                <li
                                    onClick={() => handleAction({url: '/agregar-regalos', action: 'navigate'})}
                                    className={ `${styles?.movilClass} ${styles?.linksUrl}` }
                                    aria-hidden
                                >Agregar regalos</li>
                                <li
                                    onClick={() => handleAction({url: '/regalos-recibidos', action: 'navigate'})}
                                    className={ `${styles?.movilClass} ${styles?.linksUrl}` }
                                    aria-hidden
                                >Regalos recibidos</li>
                                <li
                                    onClick={() => handleAction({url: 'compartir', action: 'modal'})}
                                    className={ `${styles?.movilClass} ${styles?.linksUrl}` }
                                    aria-hidden
                                >Compartir mi mesa</li>
                                <li
                                    onClick={() => handleAction({url: '/rsvp', action: 'navigate'})}
                                    className={ `${styles?.movilClass} ${styles?.linksUrl}` }
                                    aria-hidden
                                >Mis invitados</li>
                            </ul>
                        </dd>
                    </dl>

                    <dl>
                        <dt className={styles?.titlesSubMenu}>
                            <img className={styles?.imageClass} src={CelIcon} alt="msgicon" height="20" />
                            <p>Mis mesas</p>
                        </dt>
                        <dd>
                            <ul className={styles?.floatMenuMobile}>
                                <li
                                    onClick={() => handleAction({url: '/buscar-evento', action: 'navigate'})}
                                    className={ `${styles?.movilClass} ${styles?.linksUrl}` }
                                    aria-hidden
                                >Buscar evento</li>
                                <li
                                    onClick={() => handleAction({url: '/mis-mesas', action: 'navigate'})}
                                    className={ `${styles?.movilClass} ${styles?.linksUrl}` }
                                    aria-hidden
                                >Buscar mis mesas</li>
                            </ul>
                        </dd>
                    </dl>

                    <dl>
                        <dt className={styles?.titlesSubMenu}>
                            <svg
                                xmlns="http://www.w3.org/2000/svg"
                                height="1.2em"
                                viewBox="0 0 512 512"
                                className={styles?.imageClass}
                            >
                                <path d="M464 256A208 208 0 1 0 48 256a208 208 0 1 0 416 0zM0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zm169.8-90.7c7.9-22.3 29.1-37.3 52.8-37.3h58.3c34.9 0 63.1 28.3 63.1 63.1c0 22.6-12.1 43.5-31.7 54.8L280 264.4c-.2 13-10.9 23.6-24 23.6c-13.3 0-24-10.7-24-24V250.5c0-8.6 4.6-16.5 12.1-20.8l44.3-25.4c4.7-2.7 7.6-7.7 7.6-13.1c0-8.4-6.8-15.1-15.1-15.1H222.6c-3.4 0-6.4 2.1-7.5 5.3l-.4 1.2c-4.4 12.5-18.2 19-30.6 14.6s-19-18.2-14.6-30.6l.4-1.2zM224 352a32 32 0 1 1 64 0 32 32 0 1 1 -64 0z" />
                            </svg>
                            <p
                                onClick={() => handleAction({url: '/faqs', action: 'navigate'})}
                                className={styles?.linksUrl}
                                aria-hidden
                            >Preguntas Frecuentes</p>
                        </dt>
                    </dl>

                    <dl>
                        <dt className={styles?.titlesSubMenu}>
                            <img className={styles?.imageClass} src={MsgIcon} alt="msgicon" height="20" />
                            <p
                                onClick={() => handleAction({url: '/review', action: 'navigate'})}
                                className={styles?.linksUrl}
                                aria-hidden
                            >Reseñas</p>
                        </dt>
                    </dl>

                    <dl>
                        <dt>
                            <li
                                onClick={() => handleAction({url: '/crear-mesa', action: 'navigate'})}
                                className="btn primaryButton"
                                aria-hidden
                                >Crear mesa</li>
                        </dt>
                    </dl>
                    

                </div>
            </div>

            {getOpenModal
                ? <PrintQR variant="none" getOpenModal={getOpenModal} closeModal={handleCloseModal}  />
                : null
            }
        </>
    )
}

const GiftsHeader = (props) => {

    const {
        sendProducts,
        setResponseTable,
        setTotal,
        setIsEmpty
    } = props
    
    const history = useHistory()
    const routeUrl = window.location.search
    const [showHeader, setShowHeader ] = useState(true)
    const isLogged = decodeStorage('session_token');

    useEffect(()=>{
        const agentStaff = routeUrl?.indexOf('agent_staff')
        // const agentID = routeUrl?.indexOf('agent_table_id')
        
        if(agentStaff >= 1){
            setShowHeader(false)
        }
    },[])

    const showMenuInPaths = [
        {title:'Mi mesa', url:'/my-table', action:'navigate', id:1},
        {title:'Agregar regalos', url:'/agregar-regalos', action:'navigate', id:2},
        {title:'Regalos recibidos', url:'/regalos-recibidos', action:'navigate', id:3},
        {title:'Compartir mi mesa', url: 'compartir', action:'modal', id:4},
        {title:'Buscar evento', url:'/buscar-evento', action:'navigate', id:5}
    ]
    const [getOpenModal, setOpenModal] = useState(false);
    const urlActual = window.location.pathname.split('/Mesa-de-Regalos')[1]

    const handleAction = (data) => {
        const {url, action} = data
        if(action === 'navigate'){
            history.push(url)
        }
        if(action === 'modal'){
            setOpenModal(true)
        }
    }

    const handleCloseModal = () => {
        setOpenModal(false);
    };

    return(
        isLogged && isLogged?.length
            ?
                <div className={!showHeader ? styles?.hiddenMenuAdmin : `containerPortal ${styles?.externalContainer} `}>
                    <div className={styles?.contModulesMenu}>
                        
                        <InternalMenu />
        
                        <SelectEvent
                            sendProducts={sendProducts}
                            setResponseTable={setResponseTable}
                            setTotal={setTotal}
                            setIsEmpty={setIsEmpty}
                        />
        
                        <div className={styles?.constMenu}>
                            {
                                showMenuInPaths.map((navigate) => (
                                    <div 
                                        key={navigate.id} 
                                        onClick={() => handleAction({url: navigate.url, action: navigate.action})} 
                                        className={ urlActual === navigate.url ? `${styles?.active} ${styles?.menuNav}` : styles?.menuNav }
                                        aria-hidden
                                    >{navigate.title}</div>
                                ))
                            }
                        </div>
                        {getOpenModal
                            ? <PrintQR variant="none" getOpenModal={getOpenModal} closeModal={handleCloseModal}  />
                            : null
                        }
                    </div>
                </div>
            : null
    )
}

export default GiftsHeader